import { createCrudSlice } from "./createCrudSlice";
import {
  ADD_STORE_CAMERA,
  GET_STORE_CAMERAS,
  UPDATE_STORE_CAMERA,
  UPDATE_STORE_CAMERA_STATUS,
  GET_STORE_CAMERA_DETAILS,
  DELETE_STORE_CAMERA,
} from "helpers/url_helper";

const storeCameraSlice = createCrudSlice({
  name: "storeCameras",
  urls: {
    getList: GET_STORE_CAMERAS,
    add: ADD_STORE_CAMERA,
    update: UPDATE_STORE_CAMERA,
    updateMethod: "put",
    updateStatus: UPDATE_STORE_CAMERA_STATUS,
    getDetails: GET_STORE_CAMERA_DETAILS,
  },
  initialFilters: {},
  additionalThunks: {
    deleteStoreCamera: {
      type: "storeCameras/delete",
      url: (id) => `${DELETE_STORE_CAMERA}/${id}`,
      method: "delete",
      loadingKey :"isDeleting"
    },
  },
});

// Export actions
export const { setFilter, resetFilters } = storeCameraSlice.actions;

// Export thunks
export const {
  getList: getStoreCameras,
  add: addStoreCamera,
  update: updateStoreCamera,
  deleteStoreCamera,
  updateStatus: updateStoreCameraStatus,
  getDetails: getStoreCameraDetails,
} = storeCameraSlice.thunks;

// Export reducer
export default storeCameraSlice.reducer;
